import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs';
import { ConfigurationClientService } from '../services/client/configuration-client.service';

@Injectable({
  providedIn: 'root',
})
export class LoginRouteGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private config: ConfigurationClientService
  ) {}

  canActivate(): Observable<boolean> {
    return this.authService.isAuthenticatedWait().pipe(
      take(1),
      map((isAuthenticated) => {
        if (isAuthenticated) {
          console.log('LoginRouteGuard: User is authenticated');
          this.router.navigate([
            this.config.getSetting('general', 'landingRoute'),
          ]);
          return false;
        }
        return true;
      })
    );
  }
}
